import("./bootstrap");

export const anAsyncBoundaryForModuleFederation =
  "https://webpack.js.org/concepts/module-federation/#troubleshooting";
